























































import { numberHigherRule } from "@/lib/rules/numberHigherRule";
import { numberLowerRule } from "@/lib/rules/numberLowerRule";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReport } from "@/models/report.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class ClaimSettlementForm extends mixins(PermissionMixin) {
  @Prop() value!: IReport;

  @Prop({ default: false, type: Boolean }) readonly!: boolean;

  get isRelativeValueRule() {
    return [numberHigherRule(0), numberLowerRule(100)];
  }
}
